import React from 'react';
import { motion } from 'framer-motion';
import { PaintRoller, Hammer, ArrowRight } from 'lucide-react';
export function Services() {
  return <section id="services" className="py-20 md:py-32 bg-warmWhite" data-id="element-153">
      <div className="container mx-auto px-4 md:px-6" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-155">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-charcoal tracking-tight mb-4" data-id="element-156">
            What We Do
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto rounded-full" data-id="element-157" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-158">
          {/* Painting Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="group bg-white p-8 md:p-12 rounded-xl shadow-sm border border-warmGray hover:shadow-md transition-shadow flex flex-col h-full" data-id="element-159">
            <div className="w-16 h-16 bg-warmGray rounded-full flex items-center justify-center mb-8 group-hover:bg-gold/10 transition-colors" data-id="element-160">
              <PaintRoller className="w-8 h-8 text-charcoal group-hover:text-gold transition-colors" data-id="element-161" />
            </div>
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-162">
              Painting Services
            </h3>
            <p className="text-charcoal/70 text-lg mb-8 flex-grow leading-relaxed" data-id="element-163">
              Interior & exterior painting, cabinet refinishing, drywall repair,
              and color consultations. Flawless finishes every time, using
              premium materials for lasting beauty.
            </p>
            <a href="#contact" className="inline-flex items-center gap-2 text-gold font-semibold hover:text-gold/80 transition-colors group/link" data-id="element-164">
              Learn More
              <ArrowRight className="w-5 h-5 group-hover/link:translate-x-1 transition-transform" data-id="element-165" />
            </a>
          </motion.div>

          {/* Remodeling Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="group bg-white p-8 md:p-12 rounded-xl shadow-sm border border-warmGray hover:shadow-md transition-shadow flex flex-col h-full" data-id="element-166">
            <div className="w-16 h-16 bg-warmGray rounded-full flex items-center justify-center mb-8 group-hover:bg-gold/10 transition-colors" data-id="element-167">
              <Hammer className="w-8 h-8 text-charcoal group-hover:text-gold transition-colors" data-id="element-168" />
            </div>
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-169">
              Remodeling Services
            </h3>
            <p className="text-charcoal/70 text-lg mb-8 flex-grow leading-relaxed" data-id="element-170">
              Kitchens, bathrooms, flooring, custom built-ins, and full home
              renovations. From concept to completion, we handle every detail
              with precision and care.
            </p>
            <a href="#contact" className="inline-flex items-center gap-2 text-gold font-semibold hover:text-gold/80 transition-colors group/link" data-id="element-171">
              Learn More
              <ArrowRight className="w-5 h-5 group-hover/link:translate-x-1 transition-transform" data-id="element-172" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}